import React, { useMemo } from 'react';
import { Breadcrumb, Tabs, Typography, Alert, Space, Tag } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { LimsNavIcon } from '../../components/LimsNavIcon';
import { TeamOpenSharedPanel, CrossTeamSharedPanel } from './SharedPlatformPanels';
import '../MemberManagement.css';
import './SharedPlatformPage.css';

const { Title, Paragraph } = Typography;

const SharedPlatformPage: React.FC = () => {
  const tabItems = useMemo(
    () => [
      {
        key: 'team-open',
        label: '本团队对外开放预约',
        children: <TeamOpenSharedPanel />
      },
      {
        key: 'cross-team',
        label: '全平台多团队共享预约',
        children: <CrossTeamSharedPanel />
      }
    ],
    []
  );

  return (
    <div className="page-container full-height members-lims sp-root">
      <Breadcrumb className="sp-breadcrumb">
        <Breadcrumb.Item>
          <HomeOutlined />
          <span>首页</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>仪器管理</Breadcrumb.Item>
        <Breadcrumb.Item>共享平台</Breadcrumb.Item>
      </Breadcrumb>

      <div className="page-header sp-header">
        <div className="sp-header-titles">
          <Title level={2} className="page-title sp-title">
            <LimsNavIcon name="hub" sizePx={28} className="sp-title-icon" />
            共享平台
          </Title>
          <Paragraph type="secondary" className="page-subtitle sp-subtitle">
            对外开放预约与多团队联合预约的统一入口。当前为界面骨架，配置与接口将在后续版本接入。
          </Paragraph>
        </div>
        <Space wrap>
          <Tag color="blue">占位页面</Tag>
          <Tag>通知模板扩展（接待人 / 时间）</Tag>
        </Space>
      </div>

      <Alert
        type="info"
        showIcon
        className="sp-alert"
        message="产品说明已按最新规则对齐"
        description="外部用户可加入多个团队（团队码 + 各团队管理员审批）；单团队对外与多团队平台对同一仪器互斥，由开关控制归属；审批侧将覆盖撤销与改期等能力。"
      />

      <Tabs defaultActiveKey="team-open" items={tabItems} className="sp-tabs" />
    </div>
  );
};

export default SharedPlatformPage;
